function isE164Number(value) {
  if (value.length < 2 || value[0] !== "+")
    return !1;
  for (var i = 1; i < value.length; ) {
    var character = value.charCodeAt(i);
    if (!(character >= 48 && character <= 57)) return !1;
    i++;
  }
  return !0;
}
function validateE164Number(value) {
  isE164Number(value) || console.error("[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got", value);
}
export {
  isE164Number as default,
  validateE164Number
};
//# sourceMappingURL=isE164Number.js.map
